<template>
  <div>
    <b-row class="mt-2">
      <div class="w-100 mx-3 d-flex justify-content-between align-items-center">
        <h4 class="mb-0">LEAVE CALENDAR</h4>

        <span
          v-if="!isPickDate"
          class="cursor-pointer"
          style="font-size: 12px"
          @click="pickDate">
          <i class="fa fa-calendar"/>
          {{ formattedDate }}
        </span>

        <j-datepicker
          v-else
          :auto-open="true"
          v-model="selectedDate"
          format="MMM dd, yyyy"
          @selected="changedDate"
        />
      </div>

      <b-col
        cols="12"
        style="min-height: 300px; max-height: 300px; overflow-x: auto;">
        <div
          v-if="leave_employee_list.length <= 0"
          class="d-flex align-items-center justify-content-center"
          style="height: 250px"
        >
          <div class="d-flex flex-column align-items-center no-leave">
            <img
              :src="require('@/assets/icon/info.png')"
              width="60"
              height="60"
            >
            <h6>Data is empty</h6>
            <h6>There is no employee on leave</h6>
          </div>
        </div>

        <div
          v-for="item in leave_employee_list"
          v-else
          :key="item.id"
          class="mt-3"
        >

          <div class="d-flex align-items-center">
            <div
              :style="`background-image: url('${item.photo_url ? item.photo_url : 'https://corp.jojonomic.com/assets/img/user3.png'}');`"
              style="flex: none !important"
              class="ava-profile m__r--10"/>
            <span style="font-size: 10px">
              <strong style="font-size: 14px">
                {{ item.employee_name }}
              </strong> <br>
              {{ item.type_name }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      isPickDate: false,
    };
  },
  computed: {
    ...mapState('jStoreLeave', ['leave_employee_list']),

    formattedDate() {
      return this.$moment(this.selectedDate).format('ddd, D MMMM YYYY');
    },

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },
  created() {
    const infoMonitor = JSON.parse(this.element.info).monitor || '';
    if (infoMonitor === 'by_restriction' && !this.isAdmin) {
      this.getListLeaveEmployeesByRestriction();
    } else {
      this.getListLeaveEmployees();
    }
  },
  methods: {
    ...mapActions('jStoreLeave', ['actionGetLeaveEmployee', 'actionGetLeaveEmployeeByRestriction']),

    changedDate(val) {
      this.selectedDate = this.$moment(val).format('YYYY-MM-DD');
      this.isPickDate = false;
      const infoMonitor = JSON.parse(this.element.info).monitor || '';
      if (infoMonitor === 'by_restriction' && !this.isAdmin) {
        this.getListLeaveEmployeesByRestriction();
      } else {
        this.getListLeaveEmployees();
      }
    },
    pickDate() {
      this.isPickDate = true;
    },
    getListLeaveEmployees() {
      const params = {
        pagination: {
          limit: 1000,
          page: 1,
          column: '',
          ascending: false,
          query: '',
        },
        start_date: this.selectedDate,
        end_date: this.selectedDate,
      };
      this.actionGetLeaveEmployee(params);
    },
    getListLeaveEmployeesByRestriction() {
      const params = {
        status: 'approved',
        limit: 1000,
        page: 1,
        column: 'status',
        ascending: false,
        start_date: this.selectedDate,
        end_date: this.selectedDate,
      };
      this.actionGetLeaveEmployeeByRestriction(params);
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-leave {
    img {
      width: 32px;
      height: 32px;
      margin-bottom: 10px;
    }
    h6 {
      font-family: 'Poppins-Regular';
      font-size: 12px;
      color:#989898;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jLeaveAllEmployeeWidget.vue